
import ShippingSource from "@/api/ShippingSource.js";

export const shippingModule = {
    state: () => ({
        error: false,
        errorMessage: null,
        formErrors: {
            shipping_address: {
                custom_field: {
                    address: []
                }
            }
        },
        isLoader: false,
        showModal: false,
        checkAddressCoordinate: null,
        shippingTabSelected: 'flat.flat',
        addToCartAfterSetShipping: null,
        shipping: null,
        polygons: [],
        allPolygons: [],
        pickupData: {},
        isPolygonsLoaded: false
    }),
    mutations: {
        setShipping(state, data) {
            state.shipping = data;
        },
        setAddToCartAfterSetShipping(state, data) {
            state.addToCartAfterSetShipping = data;
        },
        setShippingTabSelected(state, data) {
            state.shippingTabSelected = data;
        },
        setError(state, data) {
            state.error = data;
        },
        setErrorMessage(state, data) {
            state.error = !!data;
            state.errorMessage = data;
        },
        resetFormErrors(state) {
            state.error = false;
            state.formErrors = {
                shipping_address: {
                    custom_field: {
                        address: []
                    }
                }
            };
        },
        setFormErrors(state, data) {
            state.error = !!data;
            state.formErrors = data;
        },
        setShowModal(state, value) {
            state.showModal = value;
        },
        setPolygonsList(state, data) {
            state.polygons = data;
        },
        setLoader(state, value) {
            state.isLoader = value;
        },

        setPickupData(state, value = {}) {
            state.pickupData = value;
        },

        updatePickupData(state, value = {}) {
            state.pickupData = { ...state.pickupData, ...value };
        },
    },
    getters: {
        getAddressString: (state) => {
            let address = null;
            if(state.shipping?.code === 'pickup.pickup'){
                address = state.shipping?.institution?.address;
            }else if(state.shipping?.code === 'flat.flat') {
                address = state.shipping.address['9']
            }
            return  address;
        },

        pickupData: (state) => state.pickupData,
        pickupList: (state, getters, rootState) => {
            const currentCity = rootState.city.currentCity

            if (!currentCity) {
                return []
            }

            return getters.pickupListByCity(currentCity.store_id)
        },
        pickupListByCity: (state, getters, rootState) => (cityId) => {
            const city = rootState.city.cities.find((city) => city.store_id === cityId);

            return city?.pickups || [];
        }
    },
    actions: {
        async loadPolygonsList({rootState, commit, state}) {
            if (state.isPolygonsLoaded) {
                return
            }

            try {
                const data = await this.$API.manager.getSource(ShippingSource).polygonsList({store_id: rootState.city.currentCity.store_id ?? 0})
                commit('setPolygonsList', data)
            } catch {
                commit('setPolygonsList', [])
            } finally {
                state.isPolygonsLoaded = true
            }
        },
        async allPolygonsList({state}) {
            try {
                state.allPolygons = await this.$API.manager.getSource(ShippingSource).polygonsList();
            } catch {
                state.allPolygons = [];
            }
        },
        async initShipping({state, commit, dispatch}) {
            commit('setLoader', true)
            await  this.$API.manager.getSource(ShippingSource).selected().then((response) => {
                if(state.shipping?.code !== response['shipping_method']?.code){
                    dispatch('catalog/load', null, {root: true})
                    dispatch('catalog/popular_load', null, {root: true})
                    dispatch('cart/load', null, {root: true})
                }
                commit('setShipping', response['shipping_method']);
            }).catch(() => {
                commit('setShipping', null);
            }).finally(() => {
                commit('setLoader', false)
            })
        },
        async setShippingMethod({state, commit, dispatch, rootState}, { data }) {

            commit('setLoader', true);
            commit('setErrorMessage', null);
            commit('setError', false);
            commit('resetFormErrors');
            const response = await this.$API.manager.getSource(ShippingSource).setShipping(data).then(async (response) => {

                if(parseInt(response.shipping_method.institution['city_id']) != rootState.city.currentCity?.store_id){
                    let hostCity = rootState.city.cities.find(city => city.store_id == parseInt(response.shipping_method.institution['city_id']))
                    if(hostCity?.url){
                        rootState.mainLoader = true;
                        window.location.href = hostCity?.url;
                        return;
                    }
                }

                await dispatch('initShipping');
                commit('setShowModal', false);
                if(state.addToCartAfterSetShipping){
                    await dispatch('cart/add', {product_id: state.addToCartAfterSetShipping.product_id,  options: state.addToCartAfterSetShipping?.options ?? []}, { root: true }).catch(() => {});
                    state.addToCartAfterSetShipping = null;
                }

                return response
            }).catch((error) => {
if(error?.response?.data?.errors){
                     commit('setFormErrors', error.response?.data?.errors);
                 }
                if(error?.response?.data?.error){
                    commit('setErrorMessage', error?.response?.data?.error);
                }
                commit('setError', true);
                return Promise.reject(error);
            }).finally(async () => {
                commit('setLoader', false);
            })

            return response
        },
        async checkAddress({commit, state}, data) {
            state.checkAddressCoordinate = null
            commit('setError', false);
            commit('setErrorMessage', null);
            await this.$API.manager.getSource(ShippingSource).checkAddress(data).then((response) => {

                if(response.error){
                    commit('setError', true);
                    commit('setErrorMessage', response.error);
                }
                if(response?.coordinate){
                    state.checkAddressCoordinate = response?.coordinate;
                }
            })
        },
        async pointInPolygon({commit, state}, data) {
            state.checkAddressCoordinate = null
            commit('setError', false);
            commit('setErrorMessage', null);
            await this.$API.manager.getSource(ShippingSource).pointInPolygon(data).then((response) => {
                if(response?.lat){
                    state.checkAddressCoordinate = response;
                }
            }).catch((errorData) => {
                if(errorData?.response?.data?.error){
                    commit('setError', true);
                    commit('setErrorMessage', errorData?.response?.data?.error);
                }
            })
        },
        async changeHouse({commit, state}, data) {
            commit('setError', false);
            commit('setErrorMessage', null);
            await this.$API.manager.getSource(ShippingSource).changeHouse(data).then((response) => {
                if(response.error){
                    commit('setError', true);
                    commit('setErrorMessage', response.error);
                }

            })
        },

        setPickupData({ commit }, data) {
            commit('setPickupData', data);
        },

        updatePickupData({ commit }, data) {
            commit('updatePickupData', data);
        },

        setShipping({ commit }, data) {
            commit('setShipping', data);
        }
    },
    namespaced: true
}
